import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import Donate from "./pages/Donate";
import OurStory from "./pages/OurStory";
import Brochures from "./pages/Brochures";
import NotFoundPage from "./pages/NotFoundPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToSection from "./utils/ScrollToSection";
import ScrollToTop from "./utils/ScrollToTop";

import AdminPanel from "./adminPanel";
import AdminLogin from "./adminPanel/AdminLogin";
import AdminRoute from "./adminPanel/AdminRoute";
import { pageview, GA_TRACKING_ID } from "./utils/gtag";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const App = () => {
  const location = useLocation();  //gives us current location (path & search query parameters also)

  useEffect(() => {
    // Only initialize gtag once
    if (!window.gtag) {
      const script1 = document.createElement("script");
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
      document.head.appendChild(script1);

      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_TRACKING_ID}');
      `;
      document.head.appendChild(script2);
    }
  }, []);

useEffect(() => {
  console.log("GA tracking pageview:", location.pathname + location.search);
  pageview(location.pathname + location.search);
}, [location]);


  return (
    <>
      <ScrollToSection />
      <ScrollToTop />

      <Routes>
        {/* Public Site */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/brochures" element={<Brochures/>}/>
          <Route path="*" element={<NotFoundPage />} />
        </Route>

        {/* Admin Panel */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route
          path="/admin/*"
          element={
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          }
        />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default App;
